import {UserService, AuthenticationError} from '@/services/user';
import {TokenService} from '@/services/token';
import router from '@/router';


const state = {
  authenticating: false,
  accessToken: TokenService.getToken(),
  authenticationErrorCode: 0,
  authenticationError: '',
  refreshTokenPromise: null,
  user: null,
};

const getters = {
  loggedIn: (state) => {
    return !!state.user;
  },

  user: (state) => {
    return state.user;
  },

  authenticationErrorCode: (state) => {
    return state.authenticationErrorCode
  },

  authenticationError: (state) => {
    return state.authenticationError
  },

  authenticating: (state) => {
    return state.authenticating
  }
};

const actions = {
  async login({commit, dispatch}, {username, password}) {
    commit('loginRequest');

    try {
      const token = await UserService.login(username, password);
      commit('loginSuccess', token);
      dispatch('getUserData');
    } catch (e) {
      if (e instanceof AuthenticationError) {
        commit('loginError', {errorCode: e.errorCode, errorMessage: e.message})
      }

      return false
    }
  },

  loginReset({commit}) {
    commit('loginReset');
  },

  logout({commit}) {
    UserService.logout();
    commit('logoutSuccess');
    if(router.currentRoute.name === 'Login'){
      return;
    }
    router.push('/login');
  },

  async getUserData({commit, dispatch}) {
    try {
      const user = await UserService.getUserData();
      if (user.status) {
        commit('userFetchSuccess', user);
        router.push('/');
        return true;
      }
      commit('loginError', {errorCode: '', errorMessage: 'Geen toegang.'});
      dispatch('logout');
      return false;
    } catch (e) {
      if (e instanceof AuthenticationError) {
        commit('loginError', {errorCode: e.errorCode, errorMessage: e.message})
      }
      return false
    }
  },

  async refreshUserData({commit}) {
    try {
      const user = await UserService.getUserData();
      if (user.status) {
        commit('userFetchSuccess', user);
        return true;
      }
      return false;
    } catch (e) {
      if (e instanceof AuthenticationError) {
        commit('loginError', {errorCode: e.errorCode, errorMessage: e.message})
      }
      return false
    }
  },

  refreshToken({commit, state}) {
    if (!state.refreshTokenPromise) {
      const promise = UserService.refreshToken();
      commit('refreshTokenPromise', promise);
      promise
        .then(res => {
          commit('refreshTokenPromise', null);
          if (res) {
            commit('loginSuccess', res);
          }
        }, error => {
          console.warn(error);
          commit('refreshTokenPromise', null);
        });
    }
    return state.refreshTokenPromise;
  }
};

const mutations = {
  loginRequest(state) {
    state.authenticating = true;
    state.authenticationError = '';
    state.authenticationErrorCode = 0;
  },

  loginReset(state) {
    state.authenticating = false;
  },

  loginSuccess(state, accessToken) {
    state.accessToken = accessToken;
    state.authenticating = false;
  },

  userFetchSuccess(state, user) {
    state.user = user.data;
  },

  loginError(state, {errorCode, errorMessage}) {
    state.authenticating = false;
    state.authenticationErrorCode = errorCode;
    state.authenticationError = errorMessage;
  },

  logoutSuccess(state) {
    state.accessToken = '';
    state.user = null;
  },

  refreshTokenPromise(state, promise) {
    state.refreshTokenPromise = promise;
  }
};

export const auth = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
